import { render, staticRenderFns } from "./zongheDetail.vue?vue&type=template&id=a84bdbb2&scoped=true&"
import script from "./zongheDetail.vue?vue&type=script&lang=js&"
export * from "./zongheDetail.vue?vue&type=script&lang=js&"
import style0 from "./zongheDetail.vue?vue&type=style&index=0&id=a84bdbb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84bdbb2",
  null
  
)

export default component.exports